export default __webpack_public_path__ + "static/media/1.bdce4f98.webp";